var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnHeaderLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 13.25,
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 8.97266C21.9999 8.97266 16.3999 14.5727 16.3999 22.1327C16.3999 29.6927 21.9999 35.2927 21.9999 35.2927",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5599 8.97266C22.5599 8.97266 28.1599 14.5727 28.1599 22.1327C28.1599 29.6927 22.5599 35.2927 22.5599 35.2927",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11987 24.6527C9.11987 24.6527 14.7199 28.0127 22.2799 28.0127C29.8399 28.0127 34.8799 24.6527 34.8799 24.6527",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11987 19.6129C9.11987 19.6129 14.7199 16.2529 22.2799 16.2529C29.8399 16.2529 34.8799 19.6129 34.8799 19.6129",
    stroke: "#373737",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHeaderLanguage);
export default __webpack_public_path__ + "static/media/btn_header_language.972f5dccd3105e9f1cc2d75126fd7aa6.svg";
export { ForwardRef as ReactComponent };